<ng-container>
        <ng-container *ngTemplateOutlet="inline_editor";></ng-container>
</ng-container>


<kendo-dialog  *ngIf="dialog_opened" (close)="close_dialog()" [height]="'70%'" [width]="'60%'" resizable="true" >
 <ng-container *ngTemplateOutlet="modal_editor";></ng-container>
   <kendo-dialog-actions [layout]="actions_layout" style="flex-flow: row-reverse;">
    <button kendoButton [primary]="true" (click)="close_dialog()">Close</button>
  </kendo-dialog-actions>
</kendo-dialog>



<ng-template #inline_editor>
<div [style.height]="config_height">
<kendo-editor  [iframe]="false" *ngIf="loaded " [id]="formControlName" [formControl]="control" [disabled]="is_disabled" [style]="editor_style" class="nexus-editor">
    <kendo-toolbar [overflow]="true">
        <kendo-toolbar-button *ngIf="modal_mode" [svgIcon]="fullscreenIcon" title="" class="expand-button" (click)="open_dialog(modal_editor)" [title]="'Open editor in full view to focus on your content'"></kendo-toolbar-button>
        <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-colorpicker kendoEditorForeColor view="gradient"></kendo-toolbar-colorpicker>
        <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
        <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
        <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
        <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
    </kendo-toolbar>
</kendo-editor>
</div>
</ng-template>


<ng-template #modal_editor>
 <div class="model-editor-main">
<kendo-editor  [iframe]="false" *ngIf="loaded " [id]="formControlName" [formControl]="control" [disabled]="is_disabled" [style]="editor_style">
    <kendo-toolbar [overflow]="true">
        <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-colorpicker kendoEditorForeColor view="gradient"></kendo-toolbar-colorpicker>
        <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
        <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
        <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
        <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
    </kendo-toolbar>
</kendo-editor>
</div>
</ng-template>


